module.exports = __webpack_public_path__ + "static/flags/CB-6caa45ba792e60325dcc08f10b860932.gif";